import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';

export const StyledChooseLocation = Box.withConfig<{ reversedUI: boolean }>(p => ({
  marginLeft: '2',
  fontSize: {
    base: 'sm',
    md: 'md',
  },
  _text: {
    textDecorationLine: 'underline',
    color: p.reversedUI ? theme.token('text-reversed') : primitive.bk.$bbqBrown,
  },
  marginRight: {
    md: '4',
  },
}));

interface ChooseLocationType {
  reversedUI: boolean;
  testID?: string;
}

const ChooseLocation = ({ reversedUI, testID }: ChooseLocationType) => {
  const { formatMessage } = useIntl();
  const chooseYourLocation = formatMessage({ id: 'chooseYourLocation' });

  return (
    <StyledChooseLocation
      testID={testID}
      reversedUI={reversedUI}
      accessibilityLabel={chooseYourLocation}
      accessibilityHint={formatMessage({ id: 'clickToSelectLocation' })}
    >
      {chooseYourLocation}
    </StyledChooseLocation>
  );
};

export default ChooseLocation;
